import React, { FC } from 'react';

import {
    Spacer,
    Text,
} from '@components/1-atoms';

import {
    AppTemplate
} from '@components/4-templates';

import {
    Button,
    IconButton,
} from '@components/2-molecules';

import {
  PageHeader
} from '@components/2-molecules';

import { BusinessCreateWidget, WidgetPlaidManage, WidgetManageSubscription, WidgetSubscriptions } from '@components/3-organisms';

import { ForwardedPageProps } from '@lib/constants';

import { useUser } from '@lib/hooks/useUser';
import { useBusiness, useBusinessCountryCurrency } from '@lib/hooks/useBusiness';
import { useFeedInstitutionItems } from '@lib/hooks/useFeed';
import { logout } from '@lib/service';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';

import Sandwich from '@assets/icons/sandwich';
import { useUserSubscriptions, useUserSubscriptionsManageURL } from '@lib/hooks/useUserSubscription';


const More: FC<ForwardedPageProps> = ({ navigation, data = {}, ...props }) => {

    const [user] = useUser();
    const [business, setBusiness] = useBusiness();
    const [currency, setCurrency] = useBusinessCountryCurrency();
    const [feedInstitutionItems, setFeedInstitutionItems] = useFeedInstitutionItems();

    const [userSubscription,] = useUserSubscriptions();
    const [userSubscriptionManagementURL, ] = useUserSubscriptionsManageURL();

    return (
        <AppTemplate hooks={[ user, userSubscriptionManagementURL, business, feedInstitutionItems, currency ]}>
            <PageHeader
                title={"MORE"}
                left={<IconButton icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
            />
            <Spacer h={1} />

            <BusinessCreateWidget
                data={business?.data}
                navigation={navigation}
            />
            <Spacer h={1} />

            {
                // Widget to manage Plaid feed / institution item
                (feedInstitutionItems?.data?.length > 0) ?
                    <>
                        <WidgetPlaidManage
                            navigation={navigation}
                            currency={currency?.data?.symbol}
                            data={feedInstitutionItems?.data}
                        />
                        <Spacer h={1} />
                    </>
                    :
                    null
            }

            {/* // Widget to manage subscription(s) */}
            <WidgetManageSubscription
                data={userSubscription?.data}
                managementURL={userSubscriptionManagementURL?.data}
            />
            <Spacer h={1} />

            {/* At anytime, the user can re-enroll / re-activate a subscription or */}
            {/* enroll in another subscription. */}
            <WidgetSubscriptions navigation={navigation}/>
            <Spacer h={1} />


            {/* LOG OUT BUTTON */}
            <Spacer h={3} />
            <Button bg='#CC0808' color='#FFF' onPress={() => {logout()}}>LOGOUT</Button>
            <Text xsmall color="#FFFFFF">{`Signed in as ${user?.data?.email}`}</Text>

            <Spacer h={2} />
        </AppTemplate>
    );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(More);